import AxiosService from '@/api/ApiBase';

class OrganizationService {
  getLogo() {
    return AxiosService.get<{ logo: string }>(`user/organization/logo`);
  }
}

export default new OrganizationService();
